import React from 'react'
import { useMutation } from '@apollo/client'
import { TestResult, ProvisionTestResult, ProvisionTestResultVariables } from '@modmd/data'
import Button from 'components/Button'
import Card from 'components/Card'
import { Dialog } from 'components/Dialog'
import { Loading } from 'components/Loading'
import { Text } from 'components/Typography'
import { PROVISION_TEST_RESULT, GET_TEST } from './operations'

interface Props {
  isOpen: boolean
  testId: string
  result?: TestResult | null
  onClose: () => void
}

export const ProvisionTestResultDialog: React.VFC<Props> = ({
  isOpen,
  testId,
  result,
  onClose,
}) => {
  const [provisionTestResults, provisionTestResultsData] = useMutation<
    ProvisionTestResult,
    ProvisionTestResultVariables
  >(PROVISION_TEST_RESULT, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: GET_TEST,
        variables: {
          id: testId,
        },
      },
    ],
  })
  const handleSave = async () => {
    try {
      await provisionTestResults({
        variables: {
          inputData: {
            id: testId,
          },
        },
      })
      onClose()
    } catch {
      // ignore error
    }
  }
  return (
    <Dialog isOpen={isOpen} onDismiss={onClose} maxWidth="500px">
      <Card>
        <Loading isLoading={provisionTestResultsData.loading}>
          <Card.Title onDismiss={onClose}>Release test result</Card.Title>
          <Card.Content>
            <Text>
              Are you sure you want to release <strong>{result}</strong> result?
            </Text>
          </Card.Content>
          <Card.Actions>
            <Button onClick={onClose} colorVariant="danger" appearance="ghost">
              Cancel
            </Button>
            <Button appearance="ghost" onClick={handleSave}>
              Submit
            </Button>
          </Card.Actions>
        </Loading>
      </Card>
    </Dialog>
  )
}
